import Text from "@/components/common/Typography/Text"
import CheckedIcon from "@/components/icons/CheckedIcon"
import { facilitiesIcon } from "@/constants/hotel/facilities"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { HotelRoom } from "@/lib/redux/features/hotel/type"
import { Col, Modal, Row } from "antd"
import { forwardRef, Fragment, useCallback, useImperativeHandle, useState } from "react"
import { useTranslation } from "react-i18next"

export type ModalDetailRoomFacilitiesRef = {
  open: (room: HotelRoom) => void,
  close: () => void
}

const titles: any = {
  "Languages spoken": "hotel.language",
  "Internet access": "hotel.internet_access",
  "Services and conveniences": "hotel.services_and_conveniences",
  "Cleanliness and safety": "hotel.cleanliness_and_safety",
  "For the kids": "hotel.for_kids",
  "Access": "hotel.access",
  "Getting around": "hotel.getting_around",
  "Available in all rooms": "hotel.available_in_all_rooms",
}

const ModalDetailRoomFacilities = forwardRef<ModalDetailRoomFacilitiesRef, any>((props, ref) => {
  const [room, setRoom] = useState<HotelRoom>()
  const [open, setOpen] = useState<boolean>(false)
  const { getTranslatedText } = useTETranslation()
  const { t } = useTranslation()

  const facilities = Object.entries(room?.resource?.roomTypeFacility || {})
    .filter(([name, list]) => Object.keys(list).length > 0)
  const facilitiesLeft = facilities.slice(0, 3)
  const facilitiesRight = facilities.slice(3)

  const handleOpen = useCallback((_room: HotelRoom) => {
    setRoom(_room)
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  useImperativeHandle(ref, () => {
    return {
      open: handleOpen,
      close: handleClose
    }
  }, [handleClose, handleOpen])

  return (
    <Modal
      open={open}
      title={t("common.facilities")}
      onCancel={handleClose}
      onOk={handleClose}
      okText={t("common.back")}
      cancelButtonProps={{
        style: {
          display: 'none'
        }
      }}
      width={700}
      centered
    >
      <Row gutter={15}>
        <Col xs={24} md={12}>
          {facilitiesLeft.map(([name, facilities]) => {
            return (
              <Fragment key={name}>
                <Row>
                  <Text strong>{t(titles[name] || name)}</Text>
                </Row>
                {Object.values(facilities).map((facility) => {
                  return (
                    <Row style={{ marginBlock: '0.5rem' }}>
                      <Text>
                        {facilitiesIcon[facility.propertyId] ? facilitiesIcon[facility.propertyId] : <CheckedIcon />} {getTranslatedText(facility.propertyTranslatedName, facility.propertyName)}
                      </Text>
                    </Row>
                  )
                })}
              </Fragment>
            )
          })}
        </Col>
        <Col xs={24} md={12}>
          {facilitiesRight.map(([name, facilities]) => {
            return (
              <Fragment key={name}>
                <Row>
                  <Text strong>{t(titles[name] || name)}</Text>
                </Row>
                {Object.values(facilities).map((facility) => {
                  return (
                    <Row style={{ marginBlock: '0.5rem' }}>
                      <Text>
                        {facilitiesIcon[facility.propertyId] ? facilitiesIcon[facility.propertyId] : <CheckedIcon />} {getTranslatedText(facility.propertyTranslatedName, facility.propertyName)}
                      </Text>
                    </Row>
                  )
                })}
              </Fragment>
            )
          })}
        </Col>
      </Row>
    </Modal>
  )
})

export default ModalDetailRoomFacilities